import React, { PureComponent } from 'react';
import { Trans } from 'react-i18next';
import { Button } from '@jg/react-tracking';
import Modal from '@jg/modal';
import Loading from '@jg/loading';
import Alert from '@jg/alert';
import classnames from 'classnames';
import config from '../../config';
import { IMember } from '../../types/state.d';

type Props = {
  unlinkMember: (frpId: string) => void;
  onCloseModal: () => void;
  isModalOpen: boolean;
  member: IMember;
  isInFlight?: boolean;
  isError: boolean;
};

class UnlinkMemberModal extends PureComponent<Props> {
  handleClick = async () => {
    const {
      unlinkMember,
      onCloseModal,
      member: { fundraisingPageGuid },
    } = this.props;
    try {
      await unlinkMember(fundraisingPageGuid);
      onCloseModal();
    } catch (e) {
      // error handled unlinkMember thunk, dont close modal in error case
    }
  };

  render() {
    const {
      onCloseModal,
      isModalOpen,
      member,
      isInFlight,
      isError,
      member: { fundraisingPageGuid },
    } = this.props;
    const modalClasses = classnames({
      'jg-tc-unlink-modal': true,
      'jg-tc-unlink-modal--isError': isError,
    });
    return (
      <Modal
        overlayClassName={modalClasses}
        isOpen={isModalOpen}
        onRequestClose={onCloseModal}
      >
        <div className="jg-text--center">
          <img
            className="jg-space-mvmd"
            src={`${config.publicPath}public/robot-are-you-sure.svg`}
            alt="JustGiving robot"
            width="130"
            height="123"
          />
          <h1
            className="jg-space-mbms container--heading"
            data-qa={`unlink-member-modal-${fundraisingPageGuid}`}
          >
            <Trans i18nKey="content.unlinkMemberModal.heading" />
          </h1>
          <p className="jg-text--large">
            <Trans i18nKey="content.unlinkMemberModal.paragraphone">
              If you unlink
              <strong>{{ username: member.firstName }}’s page</strong>
              it will no longer be connected to your team
            </Trans>
          </p>
          <p className="jg-text--large jg-space-mtms jg-space-mbmd jg-space-mbxl@lg">
            <Trans i18nKey="content.unlinkMemberModal.paragraphtwo" />
          </p>
        </div>
        <div className="jg-tc-button-container">
          <Button
            type="button"
            data-qa="unlink-page"
            disabled={isInFlight}
            onClick={this.handleClick}
            className="jg-btn jg-space-mbms"
            trackingData={{
              action_name: 'click',
              subtype: 'button',
              event: 'click',
              event_value: 'unlink page',
              page_section: 'admin > members > unlink',
            }}
          >
            {isInFlight ? (
              <Loading size="small" colour="white" />
            ) : (
              <Trans i18nKey="content.unlinkMemberModal.yesunlinkpage" />
            )}
          </Button>
          <Button
            type="button"
            data-qa="cancel"
            onClick={onCloseModal}
            className="jg-btn jg-btn--ghost"
            trackingData={{
              action_name: 'click',
              subtype: 'button',
              event: 'click',
              event_value: 'cancel',
              page_section: 'admin > members > unlink',
            }}
          >
            <Trans i18nKey="global.button.cancel" />
          </Button>
          {isError && (
            <Alert
              type="warning"
              displayType="inline"
              className="jg-space-mvmd"
            >
              <Trans i18nKey="global.error.fatal" />
            </Alert>
          )}
        </div>
      </Modal>
    );
  }
}

export default UnlinkMemberModal;
